// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"3a59ebfa","796":"58734d71"}[chunkId] + ".chunk.js";
};